import styled from 'styled-components';

const CalendarDateContainerView = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;

export default CalendarDateContainerView;
